var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "a",
      {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip",
            value: "Añadir Vehículo de Carga",
            expression: "'Añadir Vehículo de Carga'"
          }
        ],
        staticClass:
          "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit",
        attrs: {
          href: "#",
          "data-toggle": "modal",
          "data-target":
            "#pedestrianToCargoModal" + _vm.selectedPerson.identification_number
        }
      },
      [_c("i", { staticClass: "la la-truck" })]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id:
            "pedestrianToCargoModal" + _vm.selectedPerson.identification_number,
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "pedestrianToCargoLabel",
          "aria-hidden": "true"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-lg modal-dialog-centered",
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("capitalize")(
                        _vm._f("translate")("Vehículo de carga")
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": "Close"
                    },
                    on: { click: _vm.closeModal }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  attrs: {
                    "data-vv-scope":
                      "pedestrianToCargo" +
                      _vm.selectedPerson.identification_number
                  }
                },
                [
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "form-group m-form__group" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 m-form__group space-row-container"
                          },
                          [
                            _c(
                              "label",
                              {
                                class: {
                                  "m--font-danger": _vm.errors.has(
                                    "vehicle_type" +
                                      _vm.selectedPerson.identification_number,
                                    "pedestrianToCargo" +
                                      _vm.selectedPerson.identification_number
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("vehicle_type")
                                    )
                                  ) + "*"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.cargo.vehicle_type_id,
                                    expression: "cargo.vehicle_type_id"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "form-control m-input",
                                attrs: {
                                  "data-vv-as":
                                    "vehicle_type" +
                                    _vm.selectedPerson.identification_number,
                                  "data-vv-scope":
                                    "pedestrianToCargo" +
                                    _vm.selectedPerson.identification_number,
                                  "data-vv-name":
                                    "vehicle_type" +
                                    _vm.selectedPerson.identification_number,
                                  id:
                                    "vehicle_type" +
                                    _vm.selectedPerson.identification_number
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.cargo,
                                        "vehicle_type_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function($event) {
                                      return _vm.updateCargoTypes(
                                        _vm.cargo.vehicle_type_id
                                      )
                                    }
                                  ]
                                }
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("select_an_option")
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.cargo_vehicle_type, function(
                                  cargo_vehicle,
                                  idx
                                ) {
                                  return _c(
                                    "option",
                                    {
                                      key: idx,
                                      domProps: { value: cargo_vehicle.id }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm._f("translate")(
                                                cargo_vehicle.name
                                              )
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "vehicle_type" +
                                        _vm.selectedPerson
                                          .identification_number,
                                      "pedestrianToCargo" +
                                        _vm.selectedPerson.identification_number
                                    ),
                                    expression:
                                      "errors.has(`vehicle_type${selectedPerson.identification_number}`, `pedestrianToCargo${selectedPerson.identification_number}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "vehicle_type",
                                        _vm.errors.first(
                                          "vehicle_type" +
                                            _vm.selectedPerson
                                              .identification_number,
                                          "pedestrianToCargo" +
                                            _vm.selectedPerson
                                              .identification_number
                                        )
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 m-form__group space-row-container"
                          },
                          [
                            _c(
                              "label",
                              {
                                class: {
                                  "m--font-danger": _vm.errors.has(
                                    "cargo_type_vehicle_type" +
                                      _vm.selectedPerson.identification_number,
                                    "pedestrianToCargo" +
                                      _vm.selectedPerson.identification_number
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("vehicle_type")
                                    )
                                  ) + "* "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.cargo.cargo_vehicle_type,
                                    expression: "cargo.cargo_vehicle_type"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "form-control m-input",
                                attrs: {
                                  "data-vv-as":
                                    "cargo_type_vehicle_type" +
                                    _vm.selectedPerson.identification_number,
                                  "data-vv-scope":
                                    "pedestrianToCargo" +
                                    _vm.selectedPerson.identification_number,
                                  "data-vv-name":
                                    "cargo_type_vehicle_type" +
                                    _vm.selectedPerson.identification_number,
                                  id:
                                    "cargo_type_vehicle_type" +
                                    _vm.selectedPerson.identification_number
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.cargo,
                                      "cargo_vehicle_type",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("select_an_option")
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.cargo_type_vehicles, function(
                                  cargo_vehicle,
                                  idx
                                ) {
                                  return _vm.hideCargoType(
                                    _vm.cargo.vehicle_type_id,
                                    cargo_vehicle.type
                                  )
                                    ? _c(
                                        "option",
                                        {
                                          key: idx,
                                          domProps: {
                                            value: cargo_vehicle.name
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    cargo_vehicle.name
                                                  )
                                                )
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "cargo_type_vehicle_type" +
                                        _vm.selectedPerson
                                          .identification_number,
                                      "pedestrianToCargo" +
                                        _vm.selectedPerson.identification_number
                                    ),
                                    expression:
                                      "errors.has(`cargo_type_vehicle_type${selectedPerson.identification_number}`, `pedestrianToCargo${selectedPerson.identification_number}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "cargo_type_vehicle_type",
                                        _vm.errors.first(
                                          "cargo_type_vehicle_type" +
                                            _vm.selectedPerson
                                              .identification_number,
                                          "pedestrianToCargo" +
                                            _vm.selectedPerson
                                              .identification_number
                                        )
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 m-form__group space-row-container"
                          },
                          [
                            _c(
                              "label",
                              {
                                class: {
                                  "m--font-danger": _vm.errors.has(
                                    "truck_license_plate" +
                                      _vm.selectedPerson.identification_number,
                                    "pedestrianToCargo" +
                                      _vm.selectedPerson.identification_number
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")(
                                          "truck_license_plate"
                                        )
                                      )
                                    )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cargo.truck_license_plate,
                                  expression: "cargo.truck_license_plate"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|alpha_num|min:6|max:10",
                                  expression:
                                    "'required|alpha_num|min:6|max:10'"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                type: "text",
                                "data-vv-validate-on": "input",
                                "data-vv-scope":
                                  "pedestrianToCargo" +
                                  _vm.selectedPerson.identification_number,
                                id:
                                  "truck_license_plate" +
                                  _vm.selectedPerson.identification_number,
                                "data-vv-name":
                                  "truck_license_plate" +
                                  _vm.selectedPerson.identification_number
                              },
                              domProps: {
                                value: _vm.cargo.truck_license_plate
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.cargo,
                                    "truck_license_plate",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "truck_license_plate" +
                                        _vm.selectedPerson
                                          .identification_number,
                                      "pedestrianToCargo" +
                                        _vm.selectedPerson.identification_number
                                    ),
                                    expression:
                                      "errors.has(`truck_license_plate${selectedPerson.identification_number}`,\n                    `pedestrianToCargo${selectedPerson.identification_number}`\n                  )"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "truck_license_plate",
                                        _vm.errors.first(
                                          "truck_license_plate" +
                                            _vm.selectedPerson
                                              .identification_number,
                                          "pedestrianToCargo" +
                                            _vm.selectedPerson
                                              .identification_number
                                        )
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 m-form__group space-row-container"
                          },
                          [
                            _c(
                              "label",
                              {
                                class: {
                                  "m--font-danger": _vm.errors.has(
                                    "cargo_order" +
                                      _vm.selectedPerson.identification_number,
                                    "pedestrianToCargo" +
                                      _vm.selectedPerson.identification_number
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("cargo_order")
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cargo.cargo_order,
                                  expression: "cargo.cargo_order"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|alpha_num|min:1|max:20",
                                  expression:
                                    "'required|alpha_num|min:1|max:20'"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                type: "text",
                                "data-vv-validate-on": "input",
                                "data-vv-scope":
                                  "pedestrianToCargo" +
                                  _vm.selectedPerson.identification_number,
                                id:
                                  "cargo_order" +
                                  _vm.selectedPerson.identification_number,
                                "data-vv-name":
                                  "cargo_order" +
                                  _vm.selectedPerson.identification_number
                              },
                              domProps: { value: _vm.cargo.cargo_order },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.cargo,
                                    "cargo_order",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "cargo_order" +
                                        _vm.selectedPerson
                                          .identification_number,
                                      "pedestrianToCargo" +
                                        _vm.selectedPerson.identification_number
                                    ),
                                    expression:
                                      "errors.has(`cargo_order${selectedPerson.identification_number}`, `pedestrianToCargo${selectedPerson.identification_number}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "cargo_order",
                                        _vm.errors.first(
                                          "cargo_order" +
                                            _vm.selectedPerson
                                              .identification_number,
                                          "pedestrianToCargo" +
                                            _vm.selectedPerson
                                              .identification_number
                                        )
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.is_articulate,
                                expression: "is_articulate"
                              }
                            ],
                            staticClass:
                              "col-md-6 m-form__group space-row-container"
                          },
                          [
                            _c(
                              "label",
                              {
                                class: {
                                  "m--font-danger": _vm.errors.has(
                                    "trailer_license_plate" +
                                      _vm.selectedPerson.identification_number,
                                    "pedestrianToCargo" +
                                      _vm.selectedPerson.identification_number
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")(
                                          "trailer_license_plate"
                                        )
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cargo.trailer_license_plate,
                                  expression: "cargo.trailer_license_plate"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.is_articulate
                                    ? "required|alpha_num|min:6|max:10"
                                    : "",
                                  expression:
                                    "is_articulate ? 'required|alpha_num|min:6|max:10' : ''"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                type: "text",
                                required: _vm.is_articulate,
                                "data-vv-validate-on": "input",
                                id:
                                  "trailer_license_plate" +
                                  _vm.selectedPerson.identification_number,
                                "data-vv-name":
                                  "trailer_license_plate" +
                                  _vm.selectedPerson.identification_number,
                                "data-vv-scope":
                                  "pedestrianToCargo" +
                                  _vm.selectedPerson.identification_number
                              },
                              domProps: {
                                value: _vm.cargo.trailer_license_plate
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.cargo,
                                    "trailer_license_plate",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "trailer_license_plate" +
                                        _vm.selectedPerson
                                          .identification_number,
                                      "pedestrianToCargo" +
                                        _vm.selectedPerson.identification_number
                                    ),
                                    expression:
                                      "errors.has(`trailer_license_plate${selectedPerson.identification_number}`, `pedestrianToCargo${selectedPerson.identification_number}`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "trailer_license_plate",
                                        _vm.errors.first(
                                          "trailer_license_plate" +
                                            _vm.selectedPerson
                                              .identification_number,
                                          "pedestrianToCargo" +
                                            _vm.selectedPerson
                                              .identification_number
                                        )
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 m-form__group space-row-container"
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("cargo_vehicle_model")
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cargo.model,
                                  expression: "cargo.model"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: { type: "text" },
                              domProps: { value: _vm.cargo.model },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.cargo,
                                    "model",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 m-form__group space-row-container"
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("cargo_vehicle_brand")
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cargo.brand,
                                  expression: "cargo.brand"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: { type: "text" },
                              domProps: { value: _vm.cargo.brand },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.cargo,
                                    "brand",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 m-form__group space-row-container"
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("cargo_vehicle_color")
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cargo.color,
                                  expression: "cargo.color"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: { type: "text" },
                              domProps: { value: _vm.cargo.color },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.cargo,
                                    "color",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 m-form__group space-row-container"
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("carrier_company")
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cargo.carrier_company,
                                  expression: "cargo.carrier_company"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: { type: "text" },
                              domProps: { value: _vm.cargo.carrier_company },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.cargo,
                                    "carrier_company",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 m-form__group space-row-container"
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("container_number")
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cargo.container_number,
                                  expression: "cargo.container_number"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: { type: "text" },
                              domProps: { value: _vm.cargo.container_number },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.cargo,
                                    "container_number",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary m-btn m-btn--icon",
                        attrs: { type: "button" },
                        on: { click: _vm.handleSubmit }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")("save"))
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        ref: "closeModal",
                        staticClass: "btn btn-primary m-btn m-btn--icon",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: { click: _vm.closeModal }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")("close"))
                            )
                          )
                        ])
                      ]
                    )
                  ])
                ]
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8064fca", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8064fca","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/authorization/pedestrian_cargo_modal/PedestrianToCargo.vue
// module id = 415
// module chunks = 0 1 18 149